import styled from "styled-components/macro";
import { HeadlineProps } from "components/atoms/Headline/types";

export const HeadlineElement = styled.h3<HeadlineProps>`
  color: ${(props) => props?.theme?.headlineColor};
  margin: 0;
  font-size: ${(props) => props?.size || "16px"};
  font-weight: 700;
`;
